// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC2sWVoJ0obdwfr_tlL6PeNoddaxqECq1Q",
  authDomain: "mia-saloon.firebaseapp.com",
  projectId: "mia-saloon",
  storageBucket: "mia-saloon.firebasestorage.app",
  messagingSenderId: "822439529553",
  appId: "1:822439529553:web:590b14c22477fb645d3c70"
};

// Avoid re-initializing in HMR
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Named export that your page expects
export const db = getFirestore(app);

// (optional) default export if you ever need the app itself
export default app;